module.exports = __webpack_public_path__ + "media/img/iryo/infinita-bistro-1b241ee041d64488b772b40d93795f3c.png";